import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import Actions from 'actions/Actions';
import userActions from 'actions/UserActions';
import addToBasketActions from 'actions/AddToBasketActions';

import LanguageLocale from 'utils/LanguageLocale';
import EN from 'components/GlobalModals/InventoryAwareStorePickerModal/locales/InventoryAwareStorePickerModal_en_US';
import FR from 'components/GlobalModals/InventoryAwareStorePickerModal/locales/InventoryAwareStorePickerModal_fr_CA';
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(EN, FR);

import { userSelector } from 'selectors/user/userSelector';
import basketSelector from 'selectors/basket/basketSelector';
import preferredStoreInfoSelector from 'selectors/user/preferredStoreInfoSelector';

const localizationSelector = createStructuredSelector({
    changeStore: getTextFromResource(getText, 'changeStore'),
    viewDetails: getTextFromResource(getText, 'viewDetails'),
    myReservation: getTextFromResource(getText, 'myReservation'),
    beautyFAQ: getTextFromResource(getText, 'beautyFAQ'),
    getDirections: getTextFromResource(getText, 'getDirections'),
    findASephora: getTextFromResource(getText, 'findASephora'),
    happeningAtSephora: getTextFromResource(getText, 'happeningAtSephora'),
    viewAll: getTextFromResource(getText, 'viewAll'),
    openUntil: () => vars => getTextFromResource(getText, 'openUntil', vars)(),
    closed: getTextFromResource(getText, 'closed'),
    noStoreNear: getTextFromResource(getText, 'noStoreNear'),
    useStore: getTextFromResource(getText, 'useStore'),
    chooseThisStore: getTextFromResource(getText, 'chooseThisStore'),
    chooseYourStore: getTextFromResource(getText, 'chooseYourStore'),
    chooseStore: getTextFromResource(getText, 'chooseStore'),
    setYourLocation: getTextFromResource(getText, 'setYourLocation'),
    pickupAndDelivery: getTextFromResource(getText, 'pickupAndDelivery'),
    pickupInStore: getTextFromResource(getText, 'pickupInStore'),
    pickupNotOffered: getTextFromResource(getText, 'pickupNotOffered'),
    showResults: getTextFromResource(getText, 'showResults'),
    cancel: getTextFromResource(getText, 'cancel'),
    confirm: getTextFromResource(getText, 'confirm'),
    reservationNotOffered: getTextFromResource(getText, 'reservationNotOffered'),
    milesAway: getTextFromResource(getText, 'milesAway'),
    kmAway: getTextFromResource(getText, 'kmAway'),
    done: getTextFromResource(getText, 'done'),
    ok: getTextFromResource(getText, 'ok'),
    changeStoreMessage: getTextFromResource(getText, 'changeStoreMessage'),
    changeStoreMessage2: getTextFromResource(getText, 'changeStoreMessage2'),
    anyPromosRewardsMsg: getTextFromResource(getText, 'anyPromosRewardsMsg'),
    changeItemQtyMsg: getTextFromResource(getText, 'changeItemQtyMsg'),
    changeItemQtyMsgHeader: getTextFromResource(getText, 'changeItemQtyMsgHeader'),
    changeItemQtyMsgHeaderMoreThanOne: getTextFromResource(getText, 'changeItemQtyMsgHeaderMoreThanOne')
});

const fields = createStructuredSelector({
    localization: localizationSelector,
    user: userSelector,
    basket: basketSelector,
    preferredStoreInfo: preferredStoreInfoSelector
});

const functions = (dispatch, ownProps) => {
    const newFunctions = {
        dispatchUpdatePreferredStore: (preferredStoreInfo, shouldClearCache, isCustomerSelected) =>
            dispatch(userActions.updatePreferredStore({ preferredStoreInfo }, shouldClearCache, isCustomerSelected)),
        dispatchRefreshBasket: forceFetch => dispatch(addToBasketActions.refreshBasket(forceFetch)),
        dispatchStoreChangedFromHeader: selectedStore => dispatch(userActions.storeChangedFromHeader(selectedStore)),
        dispatchDraftStoreDetails: payload => dispatch(userActions.draftStoreDetails(payload)),
        dispatchShowInfoModal: options => dispatch(Actions.showInfoModal(options))
    };

    if (!ownProps.onDismiss) {
        newFunctions.onDismiss = () => dispatch(Actions.closeInventoryAwareStorePickerModal());
    }

    if (!ownProps.afterCallback) {
        newFunctions.afterCallback = () => {};
    }

    return newFunctions;
};

const withInventoryAwareStorePickerModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withInventoryAwareStorePickerModalProps
};
